module.exports = __webpack_public_path__ + "static/media/coming.7ab4a9fa.jpg";